export const initialValuesItemInv = {
  description: "",
  vat: "",
};
